import { render, staticRenderFns } from "./cRecipes.vue?vue&type=template&id=ef70d686&scoped=true"
import script from "./cRecipes.vue?vue&type=script&lang=js"
export * from "./cRecipes.vue?vue&type=script&lang=js"
import style0 from "./cRecipes.vue?vue&type=style&index=0&id=ef70d686&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef70d686",
  null
  
)

export default component.exports